// extracted by mini-css-extract-plugin
export default {"list":"Messages_list__cIgag","grid":"Messages_grid__eYMtY"};